document.addEventListener("DOMContentLoaded", async () => {
  //DOM ELEMENTS
  const productForm = document.querySelector("form[data-product-id]");
  const svgUrlContainer = document.getElementById("svg-url");
  const openBtn = document.getElementById("CustomizeStickerBtn");
  const urlParams = new URLSearchParams(window.location.search);
  const itemKey = urlParams.get("itemKey");
  const isPreview = urlParams.get("preview") === "true";
  let generatedFile;

  // Find the Shopify product form
  if (!productForm) {
    return;
  }

  console.log("--CURRENT PRODUCT", currentProduct)

  function showLoadingSpinner() {
      const spinner = document.getElementById("loadingSpinner");
      if (spinner) {
        spinner.style.display = "block";
      }
    }
  
  showLoadingSpinner();

  // Get the product ID from the form attribute
  const currentProductId = productForm.getAttribute("data-product-id");

  // Find the corresponding calculator
  const selectedCalculator = await window.fetchCalculator(currentProductId, isPreview);

  if (selectedCalculator) {
    renderCalculator(selectedCalculator, productForm);
    const spinner = document.getElementById("loadingSpinner");
    if (spinner) {
      spinner.style.display = "none";
    }
    addEventListeners(selectedCalculator);
  } else {
    const spinner = document.getElementById("loadingSpinner");
    if (spinner) {
      spinner.style.display = "none";
    }
    const priceComponent = document.getElementById("product_price_container");
    priceComponent.classList.add("product_price_container_visible");
    console.log("NO CALCULATOR FOUND")
    return
  }

  // <-- STICKER CREATION SECTION -->

  //Helper Functions
  async function addToCart(calculator) {
    const selectedSize = document.querySelector(
      'input[name="properties[Size]"]:checked'
    )?.value;
    const isCustomSize = selectedSize === "Custom Size";
    let width = "";
    let height = "";

    if (isCustomSize) {
      width = document.getElementById("custom-width").value.trim();
      height = document.getElementById("custom-height").value.trim();
    
      let isValid = true; // Assume form is valid initially
    
      // Validate Width
      const widthValue = parseFloat(width);
      if (width === "") {
        displayErrorMessage("custom-width", "Width can't be blank");
        isValid = false;
      } else if (isNaN(widthValue)) {
        displayErrorMessage("custom-width", "Width must be a valid number");
        isValid = false;
      } else if (widthValue < 0.75 || widthValue > 30) {
        displayErrorMessage("custom-width", "Width must be between 0.75 and 30 inches");
        isValid = false;
      } else {
        clearErrorMessage("custom-width");
      }
    
      // Validate Height
      const heightValue = parseFloat(height);
      if (height === "") {
        displayErrorMessage("custom-height", "Height can't be blank");
        isValid = false;
      } else if (isNaN(heightValue)) {
        displayErrorMessage("custom-height", "Height must be a valid number");
        isValid = false;
      } else if (heightValue < 0.75 || heightValue > 30) {
        displayErrorMessage("custom-height", "Height must be between 0.75 and 30 inches");
        isValid = false;
      } else {
        clearErrorMessage("custom-height");
      }
    
      // Prevent submission if any field is invalid
      if (!isValid) {
        return; // Stop form submission
      }
    }
    const selectedQuantity = document.querySelector(
      'input[name="properties[Quantity]"]:checked'
    )?.value;
    const selectedProof = document.querySelector(
      'input[name="properties[Proof]"]:checked'
    )?.value;
    const selectedFinish = document.querySelector(
      'input[name="properties[Finish]"]:checked'
    )?.value;
    const fileInput = document.getElementById("fileUpload");
    const notesInput = document.getElementById("notes");

    const { totalPrice, pricePerSticker } = calculateTotalPrice(calculator);
    const variantId = currentProduct.variants[0].id;
    const formattedPricePerSticker = pricePerSticker * 100;

    const properties = {
      Size: selectedSize,
      Quantity: selectedQuantity,
      Proof: selectedProof,
      Finish: selectedFinish,
      "Price per Sticker": `$${pricePerSticker}`,
      _calculator: true,
      _pricePerSticker: formattedPricePerSticker,
    };

    

    // Include custom size dimensions only if "Custom" is selected
    if (isCustomSize) {
      properties["Width"] = width;
      properties["Height"] = height;
    }

    // Capture notes if they exist
    if (notesInput && notesInput.value.trim() !== "") {
      properties["Notes"] = notesInput.value.trim();
    }

    if (fileInput && fileInput.files.length > 0) {
      showLoadingSpinner();
      try {
        const uploadedStickerUrl = await uploadFile(fileInput.files[0])
        if(uploadedStickerUrl){
          properties["Upload Image"] = uploadedStickerUrl;
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        return;
      }
    }

    if (currentProduct.handle && currentProduct.handle.includes("generator-stickers")) {
      properties._hideEditButton = true;
      showLoadingSpinner();
      try {
        const generatedStickerUrl = await uploadFile(generatedFile);
        if (generatedStickerUrl) {
          properties["_svg-url"] = generatedStickerUrl;
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        return;
      }
    }

    const data = {
      id: variantId,
      quantity: parseInt(selectedQuantity),
      properties: properties,
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((cart) => {
        showLoadingSpinner();
        window.location.href = "/cart";
      })
      .catch((error) => console.error("Error adding to cart:", error));
  }

  // Helper function to display error messages below each custom input
  function displayErrorMessage(inputId, message) {
    // Select the input element by ID
    const inputField = document.getElementById(inputId);
    if (!inputField) return;

    inputField.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center' // Scroll to the center of the screen
    });
  
    // Get the specific error message span related to the input field
    let errorMessageElement = inputField.parentElement.querySelector(`.error-message-${inputId}`);
  
    // If no error message span exists, create one
    if (!errorMessageElement) {
      errorMessageElement = document.createElement("span");
      errorMessageElement.classList.add(`error-message-${inputId}`);
      inputField.parentElement.appendChild(errorMessageElement);
    }
  
    // Set the error message content and ensure it's visible
    errorMessageElement.textContent = message;
    errorMessageElement.style.display = "block";
  }
  
  // Helper function to clear error messages below each custom input
  function clearErrorMessage(inputId) {
    // Select the input element by ID
    const inputField = document.getElementById(inputId);
    if (!inputField) return;
  
    // Find the specific error message span related to the input field
    const errorMessageElement = inputField.parentElement.querySelector(`.error-message-${inputId}`);
    
    // If an error message exists, hide it
    if (errorMessageElement) {
      errorMessageElement.style.display = "none";
    }
  }


  // Function to Render Calculator Inside the Shopify Form
  function renderCalculator(calculator, form) {
    if (!form) return;

    // Find the correct location inside the form (before Add to Cart button)
    const quantitySubmitRow = form.querySelector(".quantity-submit-row");

    // Create a wrapper div for the calculator
    const calculatorWrapper = document.createElement("div");
    calculatorWrapper.classList.add("calculator-wrapper");

    // Render Title
    let html = "";

    // Render Sizes with Default Value Selected
    html += `<div class="calc-sizes"><h3>Size</h3>`;
    calculator.sizes.forEach((size, index) => {
      const checked = index === 0 ? "checked" : "";
      html += `
        <label>
          <input 
            type="radio" 
            name="properties[Size]" 
            data-val="${size.value}" 
            value="${size.label.replace(/"/g, "&quot;")}" 
            ${checked}
          >
          <span>${size.label}</span>
        </label>
      `;
    });
    html += `</div>`;

    // Render Custom Size Inputs (Hidden by Default)
    html += `<div id="custom-size-fields" class="custom-size-fields" style="display: none;">
               <h3>Custom Size</h3>
               <label>
                 Width (inches):
                 <input type="number" id="custom-width" min="0.75" max="30" step="0.1" value="0.75">
                 <span class="error-message-custom-width" style="display: none;"></span>
               </label>
               <label>
                 Height (inches):
                 <input type="number" id="custom-height" min="0.75" max="30" step="0.1" value="0.75">
                 <span class="error-message-custom-height" style="display: none;"></span>
               </label>
             </div>`;

    // Render Quantities
    html += `<div class="calc-quantities"><h3>Quantity</h3>`;
    calculator.quantities.forEach((quantity, index) => {
      const checked = index === 0 ? "checked" : "";
      html += `
        <label class="quantity-option">
          <input 
            type="radio" 
            name="properties[Quantity]" 
            data-val="${quantity.value}" 
            value="${quantity.value}" 
            ${checked}
          >
          <div class="labels--wrapper">
            <span class="quantity-label">${quantity.value}</span>
            <span class="price-label" id="price-${quantity.value}">$0.00</span>
            <span class="savings-label" id="savings-${quantity.value}"></span>
          </div>
        </label>
      `;
    });
    html += `</div>`;

    // Render Price Per Sticker
    html += `<div class="calc-price-per-sticker">
      <h3>Price per sticker</h3>
      <span id="price-per-sticker">$0.0</span>
    </div>`;

    // Render File Upload if applicable
    // Render File Upload if applicable
    if (calculator.hasFileUpload) {
      html += `<div class="upload-image">
                 <h3 for="fileUpload">Upload File:</h3>
                 <input type="file" id="fileUpload" name="properties[File]" accept=".pdf, .png, .jpg, .jpeg, .ai, .svg, .psd, .tiff, .eps, .indd, .webp">
                 <div id="filePreview" class="file-preview"></div>
               </div>`;
    }

    // Render Notes if applicable
    if (calculator.hasNotes) {
      html += `<div class="notes">
                 <h3 for="notes">Add Notes:</h3>
                 <textarea id="notes" name="properties[Notes]"></textarea>
               </div>`;
    }

    // Render Proof Options with Default Value Selected
    const defaultProof = "I need a proof"; // Default: proof
    html += `<div class="calc-proof"><h3>Proof</h3>
      <label>
        <input 
          type="radio" 
          name="properties[Proof]" 
          value="I need a proof" 
          class="calc-prop radio" 
          data-identifier="Proof"
          checked
        >
        <span>I need a proof</span>
      </label>
      <label>
        <input 
          type="radio" 
          name="properties[Proof]" 
          value="I do not need a proof" 
          class="calc-prop radio" 
          data-identifier="Proof"
        >
        <span>I do not need a proof</span>
      </label>
    </div>`;

    // Render Finish Options with Default Value Selected
    const defaultFinish = "Gloss"; // Default: Gloss
    html += `<div class="calc-finish"><h3>Finish</h3>
      <label>
        <input 
          type="radio" 
          name="properties[Finish]" 
          value="Gloss" 
          class="calc-prop radio" 
          data-identifier="Finish"
          checked
        >
        <span>Gloss</span>
      </label>
      <label>
        <input 
          type="radio" 
          name="properties[Finish]" 
          value="Matte" 
          class="calc-prop radio" 
          data-identifier="Finish"
        >
        <span>Matte</span>
      </label>
    </div>`;

    // Render Total Price Display
    html += `<div class="price-marker">
      <label>Total</label>
      <span id="total-price">$0.0</span>
    </div>`;

    // Append to the calculator wrapper
    calculatorWrapper.innerHTML = html;

    if (quantitySubmitRow) {
      quantitySubmitRow.parentNode.insertBefore(
        calculatorWrapper,
        quantitySubmitRow
      );
    } else {
      form.appendChild(calculatorWrapper);
    }

    updateTotalPrice(calculator);
  }

  function calculateTotalPrice(calculator) {
    const selectedSize = document.querySelector('input[name="properties[Size]"]:checked')?.dataset.val || "0";
    const isCustomSize = selectedSize === "0";

    let width = 0;
    let height = 0;
    
    if (isCustomSize) {
      width = parseFloat(document.getElementById("custom-width").value) || 1;
      height = parseFloat(document.getElementById("custom-height").value) || 1;
    }

    const selectedQuantity = Number(document.querySelector('input[name="properties[Quantity]"]:checked')?.dataset.val) || 10;
    const sizeValue = isCustomSize ? 0 : parseFloat(selectedSize);
    const basePrice = calculator.basePrices.find(bp => bp.quantity === selectedQuantity)?.value || 0;
    const squareInchPrice = calculator.squareInchPrices.find(sp => sp.quantity === selectedQuantity)?.value || 0;
    const totalPriceFormula = calculator.totalPriceFormula;

    const values = {
      sizeValue,
      width,
      height,
      squareInchPrice,
      basePrice
    }

    const totalPrice = window.evaluateFormula(totalPriceFormula, values);
    
    const pricePerSticker = (totalPrice / selectedQuantity).toFixed(2);
    const formattedTotalPrice = (pricePerSticker * selectedQuantity).toFixed(2);

    return {
      totalPrice: formattedTotalPrice,
      pricePerSticker: pricePerSticker,
    };
  }

  function updateTotalPrice(calculator) {
    const selectedSize = document.querySelector('input[name="properties[Size]"]:checked')?.dataset.val || "0";
    const isCustomSize = selectedSize === "0";

    let width = 0;
    let height = 0;
    if (isCustomSize) {
      width = parseFloat(document.getElementById("custom-width")?.value) || 1;
      height = parseFloat(document.getElementById("custom-height")?.value) || 1;
    }

    const selectedQuantity = Number(document.querySelector('input[name="properties[Quantity]"]:checked')?.dataset.val) || 10;

    let firstPricePerSticker = 0;
    let firstTotalPrice = 0;

    calculator.quantities.forEach(({ value }, index) => {
      const sizeValue = isCustomSize ? 0 : parseFloat(selectedSize);
      const quantity = Number(value);
      const basePrice = calculator.basePrices.find(bp => bp.quantity === quantity)?.value || 0;
      const squareInchPrice = calculator.squareInchPrices.find(sp => sp.quantity === quantity)?.value || 0;
      const totalPriceFormula = calculator.totalPriceFormula;
      const values = {
        sizeValue,
        width,
        height,
        basePrice,
        squareInchPrice,
      }

      const totalPriceForQuantity = window.evaluateFormula(totalPriceFormula, values);

      const pricePerSticker = (totalPriceForQuantity / quantity).toFixed(2);
      const totalPrice = (pricePerSticker * quantity).toFixed(2);

      if (index === 0) {
        firstPricePerSticker = pricePerSticker;
        firstTotalPrice = totalPrice;
      }

      const savings =
        index !== 0
          ? `Save ${Math.round(
              ((firstPricePerSticker - pricePerSticker) /
                firstPricePerSticker) *
                100
            )}%`
          : "";

      const priceLabel = document.getElementById(`price-${quantity}`);
      const savingsLabel = document.getElementById(`savings-${quantity}`);

      if (priceLabel) {
        priceLabel.textContent = `$${totalPrice}`;
      }
      if (savingsLabel) {
        savingsLabel.textContent = savings;
      }

      if (quantity === selectedQuantity) {
        const selectedTotalPrice = document.getElementById("total-price");
        const selectedPricePerSticker =
          document.getElementById("price-per-sticker");

        if (selectedTotalPrice) {
          selectedTotalPrice.textContent = `$${totalPrice}`;
        }
        if (selectedPricePerSticker) {
          selectedPricePerSticker.textContent = `$${pricePerSticker}`;
        }
      }
    });
  };

  function toggleCustomInputs() {
    const selectedSize = document.querySelector(
      'input[name="properties[Size]"]:checked'
    )?.dataset.val;
    const customFields = document.getElementById("custom-size-fields");
    if (customFields) {
      customFields.style.display = selectedSize === "0" ? "block" : "none";
    }
    updateTotalPrice(selectedCalculator);
  }

  function addEventListeners(calculator) {
    document.querySelectorAll('input[name="properties[Size]"]').forEach((input) =>
      input.addEventListener("change", () => {
        toggleCustomInputs();
        updateTotalPrice(calculator);
      })
    );

    document.querySelectorAll('input[name="properties[Quantity]"]').forEach((input) => 
      input.addEventListener("change", () => {
        updateTotalPrice(calculator);
      })
    );

    document.getElementById("custom-width").addEventListener("input", () => updateTotalPrice(calculator));
    document.getElementById("custom-height").addEventListener("input", () => updateTotalPrice(calculator));

    document.getElementById("add-to-cart-btn").addEventListener("click", (event) => {
      event.preventDefault();
      if (itemKey) {
        updateItemCart(itemKey, calculator);
      } else {
        addToCart(calculator);
      }
    });

    if (document.getElementById("fileUpload")) {
      document.getElementById("fileUpload").addEventListener("change", (event) => {
        const allowedExtensions = ["pdf", "png", "jpg", "jpeg", "ai", "svg", "psd", "tiff", "eps", "indd"];
        const file = event.target.files[0];
        if (!file) return;
  
         const fileExtension = file.name.split(".").pop().toLowerCase();
        const previewContainer = document.getElementById("filePreview");
  
        if (!allowedExtensions.includes(fileExtension)) {
          previewContainer.innerHTML = `<span style="color: red;">Please upload a file in one of the following formats: PDF, PNG, JPG, AI, SVG, PSD, TIFF, EPS, or INDD.</span>`;
          event.target.value = ""; 
          return;
        }
      
        // Check if file is an image
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = (e) => {
            previewContainer.innerHTML = `
              <img src="${e.target.result}" alt="Preview" class="uploaded-image" width="100%">
            `;
          };
          reader.readAsDataURL(file);
        } else {
          previewContainer.innerHTML = `
            <div class="file-preview">
              <img src="https://s3.amazonaws.com/sjclient/assets/images/previews/unknown.png" alt="Fallback Preview" width="300">
            </div>
          `;
        }
      });
    }
    
  }

  // <-- STICKER EDITION SECTION -->

  if (itemKey) {
    showLoadingSpinner();
    const response = await fetch("/cart.js");
    const cartData = await response.json();
    const item = cartData.items.find((i) => i.key === itemKey);
    async function prefillFormFromCart(itemKey, calculator) {
      try {    
        if (!item) {
          window.location.href = `/products/${currentProduct.handle}`
        };

        document
          .querySelector(
            `input[name='properties[Size]'][value='${item.properties.Size}']`
          )
          ?.click();
        document
          .querySelector(
            `input[name='properties[Quantity]'][value='${item.properties.Quantity}']`
          )
          ?.click();
        document
          .querySelector(
            `input[name='properties[Proof]'][value='${item.properties.Proof}']`
          )
          ?.click();
        document
          .querySelector(
            `input[name='properties[Finish]'][value='${item.properties.Finish}']`
          )
          ?.click();

        if (item.properties.Size === "Custom Size") {
          document.getElementById("custom-width").value = item.properties.Width;
          document.getElementById("custom-height").value =
            item.properties.Height;
          document.getElementById("custom-size-fields").style.display = "block";
        }

        // Prefill the notes field if available
        const notesInput = document.getElementById("notes");
        if (notesInput && item.properties.Notes) {
          notesInput.value = item.properties.Notes;
        }

        const previewContainer = document.getElementById("filePreview");
        if (previewContainer && item.properties["Upload Image"]) {
          previewContainer.innerHTML = `
            <img src="${item.properties["Upload Image"]}" alt="Preview" class="uploaded-image" width="100%"  onerror="this.onerror=null; this.src='https://s3.amazonaws.com/sjclient/assets/images/previews/unknown.png'">
          `;
        }

        updateTotalPrice(calculator);
        document.getElementById("add-to-cart-btn").textContent =
          "Update Product";
        const spinner = document.getElementById("loadingSpinner");
        if (spinner) {
          spinner.style.display = "none";
        }
      } catch (error) {
        console.error("Error pre-filling form:", error);
      }
    }
    await prefillFormFromCart(itemKey, selectedCalculator);
  }

  async function updateItemCart(itemKey, calculator) {
    const selectedSize = document.querySelector(
      'input[name="properties[Size]"]:checked'
    )?.value;
    const isCustomSize = selectedSize === "Custom Size";
    let width = "";
    let height = "";

    if (isCustomSize) {
      width = document.getElementById("custom-width").value.trim();
      height = document.getElementById("custom-height").value.trim();
    
      let isValid = true; // Assume form is valid initially
    
      // Validate Width
      const widthValue = parseFloat(width);
      if (width === "") {
        displayErrorMessage("custom-width", "Width can't be blank");
        isValid = false;
      } else if (isNaN(widthValue)) {
        displayErrorMessage("custom-width", "Width must be a valid number");
        isValid = false;
      } else if (widthValue < 0.75 || widthValue > 30) {
        displayErrorMessage("custom-width", "Width must be between 0.75 and 30 inches");
        isValid = false;
      } else {
        clearErrorMessage("custom-width");
      }
    
      // Validate Height
      const heightValue = parseFloat(height);
      if (height === "") {
        displayErrorMessage("custom-height", "Height can't be blank");
        isValid = false;
      } else if (isNaN(heightValue)) {
        displayErrorMessage("custom-height", "Height must be a valid number");
        isValid = false;
      } else if (heightValue < 0.75 || heightValue > 30) {
        displayErrorMessage("custom-height", "Height must be between 0.75 and 30 inches");
        isValid = false;
      } else {
        clearErrorMessage("custom-height");
      }
    
      // Prevent submission if any field is invalid
      if (!isValid) {
        return; // Stop form submission
      }
    }
    const selectedQuantity = document.querySelector(
      'input[name="properties[Quantity]"]:checked'
    )?.value;
    const selectedProof = document.querySelector(
      'input[name="properties[Proof]"]:checked'
    )?.value;
    const selectedFinish = document.querySelector(
      'input[name="properties[Finish]"]:checked'
    )?.value;
    const fileInput = document.getElementById("fileUpload");
    const notesInput = document.getElementById("notes");

    const { totalPrice, pricePerSticker } = calculateTotalPrice(calculator);
    const formattedPricePerSticker = pricePerSticker * 100;

    const response = await fetch("/cart.js");
    const cartData = await response.json();
    const existingItem = cartData.items.find((i) => i.key === itemKey);
    const existingImageUrl = existingItem?.properties["Upload Image"] || "";
    const existingNotes = existingItem?.properties["Notes"] || "";

    const properties = {
      Size: selectedSize,
      Quantity: selectedQuantity,
      Proof: selectedProof,
      Finish: selectedFinish,
      "Price per Sticker": `$${pricePerSticker}`,
      _calculator: true,
      _pricePerSticker: formattedPricePerSticker,
    };

    // Include custom size dimensions only if "Custom" is selected
    if (isCustomSize) {
      properties["Width"] = width;
      properties["Height"] = height;
    }

    if (fileInput && fileInput.files.length > 0) {
      showLoadingSpinner();
      try {
        const uploadedStickerUrl = await uploadFile(fileInput.files[0], existingImageUrl);
        if (uploadedStickerUrl) {
          properties["Upload Image"] = uploadedStickerUrl; 
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        return;
      }
    } else if (existingImageUrl) {
      properties["Upload Image"] = existingImageUrl;
    }

    // Add notes if available
    if (notesInput) {
      properties["Notes"] = notesInput.value.trim() || existingNotes;
    }

    const data = {
      id: itemKey,
      quantity: parseInt(selectedQuantity),
      properties: properties,
    };

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((cart) => {
        showLoadingSpinner();
        window.location.href = "/cart";
      })
      .catch((error) => console.error("Error adding to cart:", error));
  }

  /**
 * Uploads a file to S3 and returns its public URL
 */
  async function uploadFile (file, unusedAsset) {
    const fileName = `${file.name.replace(/\s/g, "_").replace(/\.[^.]+$/, "")}_${new Date().toISOString().replace(/[-:.TZ]/g, "")}${file.name.match(/\.[^.]+$/)?.[0] || ""}`;
    const contentType = file.type;
    const formData = new FormData();
    formData.append("file", file, fileName);
 
    const baseAPI = "https://sticker-junkie-shopify-app-d9c55e68ab12.herokuapp.com";
    const params = new URLSearchParams({fileName, contentType});
    if (unusedAsset) {
      params.set("unusedAsset", unusedAsset)
    }
    const baseUrl = `${baseAPI}/api/calculator/asset?${params.toString()}`;
    const response = await fetch(baseUrl, {
      method: "POST",
      body: formData
    });

    const responseData = await response.json();
    return responseData.fileURL;
  }

  // <-- GENERATOR STICKERS SECTION -->
  if (currentProduct.handle && currentProduct.handle.includes("generator-stickers")) {
    const link = document.getElementById("open-svg-link");
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === "href") {
              generatedFile = window.svgFile;
              if (generatedFile) {
                svgUrlContainer.value = "Has generated file";
              } else {
                svgUrlContainer.value = "";
              }
            }
        }
    });
  
    observer.observe(link, { attributes: true });
  }
});
